import { Box } from '@/shared/ui/box';
import { SkeletonLoader } from '@/shared/ui/skeleton';
import { BodyTextBoldTertiary } from '@/shared/ui/typography';

import {
  ArrowBottomIcon,
  ArrowUpIcon,
  ClockIcon,
  WalletButton,
  Wrapper,
} from './styles';

export const WalletSkeleton = ({ t }) => {
  return (
    <Wrapper>
      <Box $padding={16}>
        <SkeletonLoader height={45} />
      </Box>
      <Box $display="flex">
        <WalletButton
          icon={<ArrowBottomIcon $active={true} />}
          variant="secondary"
          type="button"
        >
          <BodyTextBoldTertiary color="#EDEFF5">
            {t('wallet.tabs.deposit')}
          </BodyTextBoldTertiary>
        </WalletButton>
        <WalletButton
          icon={<ArrowUpIcon $active={false} />}
          variant="transparent"
          type="button"
        >
          <BodyTextBoldTertiary color="#AFAFAF">
            {t('wallet.tabs.withdraw')}
          </BodyTextBoldTertiary>
        </WalletButton>
        <WalletButton icon={<ClockIcon />} variant="transparent" type="button">
          <BodyTextBoldTertiary color="#AFAFAF">
            {t('wallet.tabs.history')}
          </BodyTextBoldTertiary>
        </WalletButton>
      </Box>
      <SkeletonLoader height={308} />
    </Wrapper>
  );
};
